/**
 * @desc getDetailList
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationFacadeImpl.getDetailList.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocation/getDetailList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
